/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XIcon32Regular = forwardRef('XIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5.747 5.747a1 1 0 0 1 1.414 0L16 14.586l8.84-8.84a1 1 0 1 1 1.413 1.415L17.414 16l8.84 8.84a1 1 0 0 1-1.415 1.413L16 17.414l-8.84 8.84a1 1 0 0 1-1.413-1.415L14.586 16l-8.84-8.84a1 1 0 0 1 0-1.413Z" })));
});
